module.exports = __webpack_public_path__ + "img/19.291e2fc8.svg";